import styled from 'styled-components'

import { theme } from '../../../styles/theme'

export const Container = styled.div`
  width: 100%;
  background-color: ${theme.colors.boldGreen2};
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0 24px 0;
  border-radius: ${theme.border.smallRadius};

  @media (min-width: 768px) {
    width: 60%;
  }
`

export const NavigateButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${theme.font.sizes.small};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.green2};
  border: none;
  background-color: transparent;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    font-weight 0.2s ease-in-out;

  &.active {
    color: ${theme.colors.white};
    font-weight: ${theme.font.bold};
    background-color: ${theme.colors.green2};
    padding: 6px 8px;
    border-radius: ${theme.border.smallRadius};
  }

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.normal};
  }
`
